import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: () => ({
    legacy: [],
    allLegaciesLoaded: false,
    meta: null,
    page: 1,
    legacyDetails: null,
    noResult: false,
  }),
  actions,
  getters,
  mutations,
};
